<template>
  <article class="media">
    <figure class="media-left" aria-hidden="true">
      <p class="image is-96x96 u-is-64x64--mobile">
        <router-link :to="{ name: 'redirect-to-offer', params: { id: item.variantId } }"
          @click.native="handleToggleDrawer" tabindex="-1">
          <img :alt="item.subtitle" fetchpriority="low" class="c-cartdrawer__img"
            v-lazy="`https://assets.urlaubsgutschein.kaufen/i/resize?width=128&quality=50&interlace=true&type=auto&file=${item.image}`"
            loading="lazy" />
        </router-link>
      </p>
    </figure>
    <div class="media-content is-size-6 is-size-7-mobile">
      <div class="has-text-weight-semibold">
        <b-tag type="is-dark" v-if="item.orderItemReduction">Promotion: {{ item.orderItemReduction.name }}</b-tag>
        <router-link class="has-text-black-ter" :to="{ name: 'redirect-to-offer', params: { id: item.variantId } }"
          @click.native="handleToggleDrawer">
          <span class="is-sr-only">{{ $t('general.article') }} {{ index }}</span>
          {{ item.title }}</router-link>
      </div>
      <div class="u-text--ellipsis">
        <small class="is-block u-text--ellipsis">{{ item.subtitle }}</small>
        <small class="is-block u-text--ellipsis">{{ item.description }}</small>
      </div>
      <div class="columns is-mobile c-cartdrawer_itemoptions is-multiline is-gapless">
        <div class="column is-6-tablet is-12-mobile">
          <b-field class="is-inline-block">
            <b-numberinput controls-position="compact" :aria-label="$t('general.quantity')"
              :name="$t('general.quantity')" v-model="item.quantity" size="is-small" type="is-dark" min="1" max="10"
              :aria-minus-label="$t('general.decrease-quantity')" :aria-plus-label="$t('general.increase-quantity')"
              @input="changeQuantity"></b-numberinput>
          </b-field>
          <span class="is-inline-block ml-2">&nbsp;à {{ item.currency | currency }} {{ item.unitPrice | amount }}</span>
        </div>
        <div class="column is-6-mobile is-3-tablet">
          <b-button name="removeButton" type="is-text" @click="removeItem" class="is-size-7 is-paddingless">
            <span class="is-sr-only">{{ $t('general.article') }}</span>
            {{ $t('general.remove') }}
          </b-button>
        </div>
        <div class="column is-size-5 is-6-mobile is-3-tablet has-text-right">
          <small class="is-linethrough" v-if="item.orderItemReduction"> {{ $t('general.instead-of') }} {{ item.currency
            | currency }} {{ (item.orderItemReduction.unitPriceBeforeReduction * item.quantity) | amount }} </small>
          <strong class="is-block">{{ item.currency | currency }} {{ item.total | amount }}</strong>
        </div>
      </div>
      <!-- VERSICHERUNGS START -->
      <div class="columns is-mobile c-cartdrawer_itemoptions is-multiline is-gapless" v-for="upgrade in item.upgrades"
        :key="upgrade.id">
        <div class="column is-6-tablet is-12-mobile is-size-6">
          <small>{{ upgrade.description }}</small>
        </div>
        <div class="column is-6-mobile is-3-tablet">
          <b-button v-if="upgrade.unitPrice > 0" name="removeInsuranceButton" type="is-text"
            @click="removeInsuranceItem" class="is-size-7 is-paddingless">{{ $t('general.remove') }}</b-button>
        </div>
        <div class="column is-6-mobile is-3-tablet is-size-6 has-text-right">
          <small class="is-block">{{ item.currency | currency }} {{ upgrade.unitPrice | amount }}</small>
        </div>
      </div>
      <!-- VERSICHERUNGS END -->
    </div>
  </article>
</template>

<script>
export default {
  name: 'CartDisplayItem',
  props: {
    item: Object,
    index: Number,
  },
  methods: {
    removeItem() {
      this.$store.dispatch('removeProduct', this.item)
    },
    removeInsuranceItem() { },
    changeQuantity(val) {
      this.$store.dispatch('changeQuantityOfProduct', {
        itemId: this.item.id,
        quantity: val,
      })
    },
    handleToggleDrawer() {
      this.$store.dispatch('hideDrawer')
    },
  },
  // computed: {
  //   routerAttr() {

  //     if (this.item.slug && this.item.slug.length > 0) {
  //       return {
  //         name: 'urlaub',
  //         params: {
  //           slug: this.item.slug,
  //           contact: this.item.contact.slug,
  //         },
  //       }
  //     }
  //     return {
  //       name: 'hotel',
  //       params: {
  //         id: this.item.id,
  //         name: this.$options.filters.removeSpecialChars(this.item.contact.name),
  //       },
  //     }
  //   },
  // },
}
</script>

<style scoped lang="scss"></style>
